const GenderEnum = {
  1: 'Male',
  2: 'Female',
  3: 'Other',
};

const GenderOptions = [
  { label: 'Male', value: 1 },
  { label: 'Female', value: 2 },
  { label: 'Other', value: 3 },
];

export { GenderEnum, GenderOptions };